module.exports = __webpack_public_path__ + "static/img/bg.13ae3a79.jpg";